export default {
  'goldkid-opened:title': 'Kaspi Gold для ребенка открыт!',
  'goldkid-opened:title-AB': 'Получите карту в отделении',
  'goldkid-opened-steps:title': 'Чтобы начать пользоваться <br/> Kaspi Gold для ребенка,',
  'goldkid-opened-steps:title-AB': 'Для получения карты Kaspi Gold <br/> для ребенка',
  'goldkid-opened-steps:step1': 'Подойдите к любому <a class="link-500 text-action-link" href="https://kaspi.kz/maps/cardomats/">Kaspi Картомату</a>',
  'goldkid-opened-steps:step2': 'Получите карту при помощи QR',
  'goldkid-opened-steps:step3': 'Установите по карте ребенка ПИН-код на&nbsp;Kaspi.kz',
  'goldkid-opened-steps:step4': 'Передайте карту и ПИН-код ребенку',
  'goldkid-opened:btn': 'Вернуться на Главную Kaspi.kz',
  'goldkid-opened:btn--AB': 'Ближайшее отделение Kaspi.kz',
  'goldkid-open:btn-qr': 'Перейти в Kaspi QR',
  'goldkid-open:btn-download': 'Отправить ссылку на скачивание',
  'goldkid-open:btn-goldkid': 'Перейти в Kaspi Gold для ребенка',
  'goldkid-open:title-re-release': 'Чтобы получить карту Kaspi&nbsp;Gold&nbsp;для&nbsp;ребенка:'
}
